import { isDogfoodEnv, getPhysicalRing } from 'owa-metatags';

/**
 * Temporary method to enable startupdata for Dogfood, MSIT and WW
 */
export default function isStartupDataEnabled() {
    return isDogfoodEnv() || getPhysicalRing() === 'MSIT' || getPhysicalRing() === 'WW';
}
